import { render, staticRenderFns } from "./Pre-loader-item.vue?vue&type=template&id=bea71dc6&scoped=true&lang=html"
import script from "./Pre-loader-item.vue?vue&type=script&lang=js"
export * from "./Pre-loader-item.vue?vue&type=script&lang=js"
import style0 from "./Pre-loader-item.vue?vue&type=style&index=0&id=bea71dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea71dc6",
  null
  
)

export default component.exports